var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Button as MuiButton, makeStyles } from "@material-ui/core";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        margin: theme.spacing(0.5),
    },
    label: {
        textTransform: "none",
    },
}); });
var Button = function (props) {
    var text = props.text, size = props.size, color = props.color, variant = props.variant, onClick = props.onClick, other = __rest(props, ["text", "size", "color", "variant", "onClick"]);
    var classes = useStyles();
    return (React.createElement(MuiButton, __assign({ variant: variant || "contained", size: size || "large", color: color || "primary", onClick: onClick }, other, { classes: { root: classes.root, label: classes.label } }), text));
};
export default Button;
//# sourceMappingURL=Button.js.map